'use client';

import React, { useState } from 'react';

interface CourseSectionProps {
  courseTitle: string;
  progressPercentage: number;
}

export function CourseSection({
  courseTitle,
  progressPercentage,
}: CourseSectionProps) {
  const [showDetails, setShowDetails] = useState(true);

  return (
    <div className="bg-gradient-sheen rounded-lg p-4 flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h6 className="cs-h6 text-text-default-light m-0">Course</h6>
      </div>
      {showDetails && (
        <>
          <h4 className="cs-h4 mb-1 text-text-default-medium m-0">
            {courseTitle}
          </h4>
          <div className="bg-surface-5 h-1 rounded-full">
            <div
              className="h-1 rounded-full bg-amethyst-accent transition-all duration-300"
              style={{ width: `${Math.max(0, Math.min(100, progressPercentage))}%` }}
            ></div>
          </div>
          <div className="cs-caption flex items-center justify-between">
            <span>
              Course:{' '}
              <span className="text-amethyst-accent">
                {Math.max(0, Math.min(100, Math.round(progressPercentage)))}%
              </span>
              {' '}Complete
            </span>
            <button
              className="cs-caption text-text-action-medium hover:text-text-action-strong bg-transparent border-0 cursor-pointer p-0"
              onClick={() => setShowDetails(!showDetails)}
            >
              {showDetails ? 'Show less' : 'Show more'}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

